var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 36,
    viewBox: "0 0 26 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 36C12.9999 36 0.399902 19.566 0.399902 12.6C0.399902 10.9453 0.725811 9.30689 1.35902 7.77819C1.99223 6.24949 2.92034 4.86047 4.09036 3.69045C5.26038 2.52044 6.64939 1.59233 8.17809 0.959118C9.70679 0.325909 11.3452 0 12.9999 0C14.6546 0 16.293 0.325909 17.8217 0.959118C19.3504 1.59233 20.7394 2.52044 21.9094 3.69045C23.0795 4.86047 24.0076 6.24949 24.6408 7.77819C25.274 9.30689 25.5999 10.9453 25.5999 12.6C25.5999 19.566 12.9999 36 12.9999 36ZM12.9999 16.2C13.9547 16.2 14.8704 15.8207 15.5455 15.1456C16.2206 14.4705 16.5999 13.5548 16.5999 12.6C16.5999 11.6452 16.2206 10.7295 15.5455 10.0544C14.8704 9.37928 13.9547 9 12.9999 9C12.0451 9 11.1294 9.37928 10.4543 10.0544C9.77919 10.7295 9.3999 11.6452 9.3999 12.6C9.3999 13.5548 9.77919 14.4705 10.4543 15.1456C11.1294 15.8207 12.0451 16.2 12.9999 16.2Z",
    fill: "#A2FE20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.646739c1377ebea26bc5b8d777c788bc.svg";
export { ForwardRef as ReactComponent };